import { BoxGeometry, CylinderGeometry } from "three";
import { writeGlb } from "./glb.js";

// A small real GLB, useful without uploading files or fetching a model library.
export function createSampleGlb() {
    const json = { asset: { version: "2.0", generator: "Model Vista Create sample" }, scene: 0,
        scenes: [{ nodes: [0] }], nodes: [
            { name: "Inspection unit", children: [1, 2, 3, 4, 5] },
            { name: "Base", mesh: 0, translation: [0, 0.06, 0], scale: [1.5, 0.12, 0.95] },
            { name: "Housing", mesh: 1, translation: [0, 0.3, 0], scale: [1.25, 0.35, 0.72] },
            { name: "Top cover", mesh: 0, translation: [0, 0.53, 0], scale: [1.3, 0.1, 0.78] },
            { name: "Rotor", mesh: 2, translation: [0.18, 0.64, 0], scale: [0.27, 0.4, 0.27], rotation: [0, 0, 0.7071067811865475, 0.7071067811865476] },
            { name: "End cap", mesh: 1, translation: [-0.48, 0.32, 0.41], scale: [0.22, 0.22, 0.18] }
        ],
        materials: [
            { name: "Machined aluminum", pbrMetallicRoughness: { baseColorFactor: [0.53, 0.61, 0.7, 1], metallicFactor: 0.85, roughnessFactor: 0.3 } },
            { name: "Blue housing", pbrMetallicRoughness: { baseColorFactor: [0.07, 0.2, 0.43, 1], metallicFactor: 0.5, roughnessFactor: 0.35 } }
        ], meshes: [], accessors: [], bufferViews: [], buffers: [{ byteLength: 0 }] };
    const parts = []; let length = 0;
    function accessor(array, itemSize, componentType, target, bounds) {
        length = Math.ceil(length / 4) * 4;
        const bytes = new Uint8Array(array.buffer, array.byteOffset, array.byteLength);
        const bufferView = json.bufferViews.length;
        json.bufferViews.push({ buffer: 0, byteOffset: length, byteLength: bytes.length, target });
        parts.push({ offset: length, bytes }); length += bytes.length;
        const index = json.accessors.length;
        json.accessors.push({ bufferView, componentType, count: array.length / itemSize, type: itemSize === 1 ? "SCALAR" : "VEC3", ...bounds });
        return index;
    }
    const box = new BoxGeometry(1, 1, 1), cylinder = new CylinderGeometry(1, 1, 1, 32);
    for (const [geometry, material] of [[box, 0], [box, 1], [cylinder, 0]]) {
        geometry.computeBoundingBox();
        const position = accessor(geometry.attributes.position.array, 3, 5126, 34962, { min: geometry.boundingBox.min.toArray(), max: geometry.boundingBox.max.toArray() });
        const normal = accessor(geometry.attributes.normal.array, 3, 5126, 34962);
        const indices = accessor(geometry.index.array, 1, 5123, 34963);
        json.meshes.push({ primitives: [{ attributes: { POSITION: position, NORMAL: normal }, indices, material }] });
    }
    const binaryChunk = new Uint8Array(Math.ceil(length / 4) * 4);
    parts.forEach(part => binaryChunk.set(part.bytes, part.offset)); json.buffers[0].byteLength = binaryChunk.length;
    box.dispose(); cylinder.dispose(); return writeGlb({ binaryChunk, chunks: [] }, json);
}
